import React from 'react';
import { GraduationCap } from 'lucide-react';
import ThemeToggle from './ThemeToggle';

// The frame of the pages outside the app (login, register, invite and not-found): the brand above one centred card.
const AuthShell: React.FC<{ children: React.ReactNode; brandAsHeading?: boolean; wide?: boolean }> = ({ children, brandAsHeading = true, wide = false }) => {
  const Brand = brandAsHeading ? 'h1' : 'p';
  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center px-4 py-16 bg-gray-50 dark:bg-gray-950 transition-colors duration-200 overflow-hidden">
      {/* A soft glow behind the card; decoration only. */}
      <div aria-hidden="true" className="pointer-events-none absolute -top-40 left-1/2 h-[28rem] w-[56rem] max-w-[200vw] -translate-x-1/2 rounded-full bg-gradient-to-b from-blue-200/50 to-transparent blur-3xl dark:from-blue-950/40" />
      <ThemeToggle className="absolute top-4 right-4" />
      <div className={`relative w-full ${wide ? 'max-w-lg' : 'max-w-md'}`}>
        <div className="mb-6 flex items-center justify-center gap-2.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-600 text-white shadow-sm">
            <GraduationCap className="w-6 h-6" />
          </span>
          <Brand className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Webots Academy</Brand>
        </div>
        <div className="card p-6 sm:p-8 shadow-lg shadow-gray-200/60 dark:shadow-none">{children}</div>
      </div>
    </div>
  );
};

export default AuthShell;
